import React, { useState, useEffect, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import TabletIcon from '@material-ui/icons/Tablet';
import PhoneIcon from '@material-ui/icons/Phone';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import SettingsIcon from '@material-ui/icons/Settings';
import LaptopIcon from '@material-ui/icons/Laptop';
import RotateScreenIcon from '@material-ui/icons/ScreenRotation';

const useStyles = makeStyles((theme) => ({
  warningDialog: {
    '& .MuiDialog-paper': {
      minWidth: '200px',
      maxWidth: '700px',
      borderRadius: '12px',
      border: '0px',
    },
  },
  warningHeader: {
    color: 'white',
    position: 'relative',
    padding: '20px 24px 16px',
  },
  warningHeaderOptimal: {
    // background: 'linear-gradient(135deg, #51D497 0%, #1D3557 100%)',
    background: '#51d497',
    // border: '2px solid #51D497',
  },
  warningHeaderSubOptimal: {
    background: '#FF9A98',
    // background: 'linear-gradient(135deg, #FF9A98 0%, #F25F5C 100%)',
    // border: '2px solid #FFC72C',
  },
  closeButton: {
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: 'white',
  },
  headerIcon: {
    fontSize: '24px',
    marginRight: '12px',
  },
  warningIcon: {
    // animation: '$pulse 2s infinite',
  },
  successIcon: {
    // animation: '$checkmark 1s ease-in-out',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.1)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
  '@keyframes checkmark': {
    '0%': {
      transform: 'scale(0.8)',
    },
    '50%': {
      transform: 'scale(1.1)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
  currentScreenInfo: {
    background: '#f5f5f5',
    padding: '16px',
    borderRadius: '8px',
    margin: '16px 0',
    border: '1px solid #e0e0e0',
  },
  currentScreenInfoOptimal: {
    background: '#e8f5e8',
    border: '1px solid #51D497',
  },
  deviceIconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '8px',
  },
  deviceIcon: {
    fontSize: '24px',
    height: '29px',
    color: '#1D3557',
    flexShrink: 0,
  },
  solutionAccordion: {
    borderRadius: '8px !important',
    marginBottom: '8px',
    border: '1px solid #e0e0e0',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: '8px 0',
    },
  },
  solutionHeader: {
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    '& .MuiAccordionSummary-content': {
      alignItems: 'center',
      margin: '12px 0',
    },
    '& .MuiAccordionSummary-root': {
      minHeight: '56px',
    },
  },
  primarySolution: {
    backgroundColor: '#e3f2fd',
    border: '2px solid #1D3557',
    boxShadow: 'none',
  },
  mobileSolution: {
    backgroundColor: '#fff3e0',
    border: '2px solid #FFC72C',
  },
  solutionIcon: {
    marginRight: '12px',
    color: '#1D3557',
    fontSize: '20px',
  },
  chipContainer: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    marginTop: '8px',
  },
  recommendedChip: {
    backgroundColor: '#1D3557',
    color: 'white',
    fontWeight: 'bold',
  },
  mobileChip: {
    backgroundColor: '#FFC72C',
    color: 'white',
    fontWeight: 'bold',
  },
  optimalChip: {
    backgroundColor: '#1D3557',
    color: 'white',
    fontWeight: 'bold',
  },
  actionButtons: {
    padding: '16px 24px',
    justifyContent: 'flex-end',
    backgroundColor: '#fafafa',
    borderRadius: '0 0 12px 12px',
  },
  buttonNormal: {
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  buttonPrimary: {
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  proTipOptimal: {
    backgroundColor: '#e8f5e8',
    border: '1px solid #51D497',
  },
  proTipWarning: {
    backgroundColor: '#fff8e1',
    border: '1px solid #FFC72C',
  },
}));

const ScreenSizeWarning = ({
  isOpen,
  onClose,
  requiedMinWidth = 1600,
  currentWidth = 1440,
  showOnlyOnce = true,
  position = 'center',
}) => {
  const classes = useStyles();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [hasShownWarning, setHasShownWarning] = useState(false);

  useEffect(() => {
    setScreenWidth(currentWidth);
    // setScreenHeight(window.innerHeight);
    // const updateScreenSize = () => {
    //   setScreenWidth(window.innerWidth);
    //   setScreenHeight(window.innerHeight);
    // };

    // window.addEventListener('resize', updateScreenSize);
    // return () => window.removeEventListener('resize', updateScreenSize);
  }, [currentWidth]);

  useEffect(() => {
    if (showOnlyOnce && hasShownWarning) return;

    if (screenWidth < requiedMinWidth && !hasShownWarning) {
      setHasShownWarning(true);
    }
  }, [screenWidth, requiedMinWidth, showOnlyOnce, hasShownWarning]);

  const handleClose = useCallback(() => {
    // Save current timestamp when user manually dismisses the popup
    const currentTime = new Date().getTime();
    localStorage.setItem('screenSizeWarningLastDismissed', currentTime.toString());
    onClose();
  }, [onClose]);

  // Check if 24 hours have passed since last dismissal
  const shouldShowPopup = () => {
    const lastDismissed = localStorage.getItem('screenSizeWarningLastDismissed');
    if (!lastDismissed) {
      return true; // Show popup if never dismissed before
    }

    const lastDismissedTime = parseInt(lastDismissed);
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - lastDismissedTime;
    const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    return timeDifference >= twentyFourHours;
  };

  // Enhanced device and browser detection
  const getDeviceInfo = () => {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;

    // Device type detection
    let deviceType = 'Desktop';
    let deviceIcon = <DesktopWindowsIcon />;

    if (/Mobile|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(userAgent)) {
      if (/iPad/i.test(userAgent)) {
        deviceType = 'iPad';
        deviceIcon = <TabletIcon />;
      } else if (/iPhone|iPod/i.test(userAgent)) {
        deviceType = 'iPhone';
        deviceIcon = <PhoneIcon />;
      } else if (/Android/i.test(userAgent)) {
        deviceType = /Mobile/i.test(userAgent) ? 'Android Phone' : 'Android Tablet';
        deviceIcon = /Mobile/i.test(userAgent) ? <PhoneIcon /> : <TabletIcon />;
      } else {
        deviceType = 'Mobile Device';
        deviceIcon = <PhoneIcon />;
      }
    } else if (/Tablet/i.test(userAgent) || (screenWidth >= 768 && screenWidth < 1024)) {
      deviceType = 'Tablet';
      deviceIcon = <TabletIcon />;
    } else if (screenWidth < 1200) {
      deviceType = 'Laptop';
      deviceIcon = <LaptopIcon />;
    }

    // OS detection
    let os = 'Unknown';
    if (/Windows/i.test(userAgent)) os = 'Windows';
    else if (/Mac/i.test(userAgent)) os = 'macOS';
    else if (/Linux/i.test(userAgent)) os = 'Linux';
    else if (/Android/i.test(userAgent)) os = 'Android';
    else if (/iOS|iPhone|iPad|iPod/i.test(userAgent)) os = 'iOS';

    // Browser detection
    let browser = 'Unknown';
    if (/Chrome/i.test(userAgent) && !/Edge/i.test(userAgent)) browser = 'Chrome';
    else if (/Firefox/i.test(userAgent)) browser = 'Firefox';
    else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) browser = 'Safari';
    else if (/Edge/i.test(userAgent)) browser = 'Edge';
    else if (/Opera/i.test(userAgent)) browser = 'Opera';

    return { type: deviceType, icon: deviceIcon, os, browser };
  };

  const deviceInfo = getDeviceInfo();
  const isOptimal = screenWidth >= requiedMinWidth;
  const isMobile = screenWidth < 768;
  const isTablet = screenWidth >= 768 && screenWidth < 1024;

  useEffect(() => {
    let interval = null;
    if (isOptimal) {
      interval = setInterval(() => {
        clearInterval(interval);
        handleClose();
      }, 3000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [handleClose, isOptimal]);

  const getDeviceSpecificSolutions = () => {
    const { os, browser } = deviceInfo;

    if (isMobile) {
      return [
        {
          id: 'desktop-alternative',
          title: 'Switch to Desktop/Laptop',
          icon: <DesktopWindowsIcon className={classes.solutionIcon} />,
          primary: true,
          mobile: true,
          content: (
            <Box>
              <Typography variant="body2" paragraph>
                For the full experience, consider using:
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Desktop computer or laptop" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Tablet in landscape mode (minimum 1024px width)" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="This application works best on larger screens" />
                </ListItem>
              </List>
            </Box>
          ),
        },
        {
          id: 'rotate',
          title: 'Rotate to Landscape Mode',
          icon: <RotateScreenIcon className={classes.solutionIcon} />,
          content: (
            <Box>
              <Typography variant="body2" paragraph>
                Turn your device sideways for a wider view:
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Rotate your phone to landscape orientation" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="This will provide more horizontal space for the interface" />
                </ListItem>
                {deviceInfo.type === 'iPhone' && (
                  <ListItem>
                    <ListItemText primary="Make sure rotation lock is disabled in Control Center" />
                  </ListItem>
                )}
              </List>
            </Box>
          ),
        },
      ];
    }

    if (isTablet) {
      return [
        {
          id: 'browser-zoom',
          title: 'Browser Zoom (Recommended)',
          icon: <ZoomOutIcon className={classes.solutionIcon} />,
          primary: true,
          content: (
            <Box>
              <Typography variant="body2" paragraph>
                Adjust browser zoom level:
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Pinch out to zoom out (75-85% recommended)" />
                </ListItem>
                {browser === 'Safari' && (
                  <ListItem>
                    <ListItemText primary="Double-tap the address bar, then pinch to zoom" />
                  </ListItem>
                )}
              </List>
            </Box>
          ),
        },
        {
          id: 'rotate-tablet',
          title: 'Use Landscape Orientation',
          icon: <RotateScreenIcon className={classes.solutionIcon} />,
          content: (
            <Box>
              <Typography variant="body2" paragraph>
                Rotate your tablet for better experience:
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Turn your tablet to landscape mode" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="This provides more horizontal space" />
                </ListItem>
              </List>
            </Box>
          ),
        },
        {
          id: 'external-display',
          title: 'Connect External Display',
          icon: <DesktopWindowsIcon className={classes.solutionIcon} />,
          content: (
            <Box>
              <Typography variant="body2" paragraph>
                Use a larger external display:
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Connect to external monitor via USB-C/HDMI" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Use wireless display if supported" />
                </ListItem>
              </List>
            </Box>
          ),
        },
      ];
    }

    // Desktop/Laptop solutions
    return [
      {
        id: 'zoom',
        title: 'Browser Zoom (Recommended)',
        icon: <ZoomOutIcon className={classes.solutionIcon} />,
        primary: true,
        content: (
          <Box>
            <Typography variant="body2" paragraph>
              The quickest way to fit more content on your screen:
            </Typography>
            <List dense>
              {os === 'macOS' ? (
                <>
                  <ListItem>
                    <ListItemText primary="Press Cmd + - (minus) to zoom out" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Or hold Cmd and scroll down with trackpad/mouse" />
                  </ListItem>
                </>
              ) : (
                <>
                  <ListItem>
                    <ListItemText primary="Press Ctrl + - (minus) to zoom out" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Or hold Ctrl and scroll down with mouse wheel" />
                  </ListItem>
                </>
              )}
              <ListItem>
                <ListItemText primary="Recommended zoom: 75-90% for optimal viewing" />
              </ListItem>
            </List>
          </Box>
        ),
      },
      {
        id: 'display',
        title: 'Display & Monitor Settings',
        icon: <SettingsIcon className={classes.solutionIcon} />,
        content: (
          <Box>
            <Typography variant="body2" paragraph>
              Optimize your display configuration:
            </Typography>
            <List dense>
              {os === 'Windows' && (
                <>
                  <ListItem>
                    <ListItemText primary="Right-click desktop → Display settings" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Set Scale to 100% (if higher)" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Increase resolution if available" />
                  </ListItem>
                </>
              )}
              {os === 'macOS' && (
                <>
                  <ListItem>
                    <ListItemText primary="System Preferences → Displays" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Choose 'More Space' scaling option" />
                  </ListItem>
                </>
              )}
              <ListItem>
                <ListItemText primary="Connect external monitor for more space" />
              </ListItem>
            </List>
          </Box>
        ),
      },
    ];
  };

  const solutions = getDeviceSpecificSolutions();

  return (
    <Dialog open={isOpen && shouldShowPopup()} className={classes.warningDialog} maxWidth={false}>
      <DialogTitle
        className={`${classes.warningHeader} ${
          isOptimal ? classes.warningHeaderOptimal : classes.warningHeaderSubOptimal
        }`}
      >
        <Box display="flex" alignItems="center">
          {isOptimal ? (
            <CheckCircleIcon className={`${classes.headerIcon} ${classes.successIcon}`} />
          ) : (
            <WarningIcon className={`${classes.headerIcon} ${classes.warningIcon}`} />
          )}
          <Box>
            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', fontSize: '20px' }}>
              {/* {isOptimal ? 'Perfect Screen Size!' : 'Screen Size Optimization Needed'} */}
              {isOptimal ? 'Optimal Screen Size Detected' : 'Screen Size Optimization Needed'}
            </Typography>
          </Box>
        </Box>
        <IconButton className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" style={{ fontSize: '15px', fontWeight: '500', marginTop: '5px' }}>
          {isOptimal
            ? 'Your current screen width provides the ideal layout, maximum readability, and the smoothest interaction for the best content optimization experience.'
            : `The content optimization experience works best on screens ${requiedMinWidth}px or wider for clear visibility and smooth interaction. A larger display ensures the best layout, readability, and usability for this workflow.`}
        </Typography>
        {/* <Box className={`${classes.currentScreenInfo} ${isOptimal ? classes.currentScreenInfoOptimal : ''}`}> */}
        <Box className={`${classes.currentScreenInfo} ${isOptimal ? classes.currentScreenInfoOptimal : ''}`}>
          <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 'bold' }}>
            Current Setup Information
          </Typography>
          <Box className={classes.deviceIconContainer}>
            <Box className={classes.deviceIcon}>{deviceInfo.icon}</Box>
            <Box>
              {/* <Typography variant="body2">
                <strong>Device:</strong> {deviceInfo.type} | <strong>OS:</strong> {deviceInfo.os} |{' '}
                <strong>Browser:</strong> {deviceInfo.browser}
              </Typography> */}
              <Typography variant="body2">
                <strong>Screen:</strong> {screenWidth}px × {screenHeight}px | <strong>Recommended:</strong>{' '}
                {requiedMinWidth}
                px+ width
              </Typography>
            </Box>
          </Box>
          <Box className={classes.chipContainer}>
            {!isOptimal && (
              <Chip
                label={`${requiedMinWidth - screenWidth}px more needed`}
                size="small"
                className={classes.optimalChip}
              />
            )}
            <Chip
              label={isOptimal ? 'Optimal' : 'Needs Optimization'}
              className={isOptimal ? classes.optimalChip : undefined}
              size="small"
            />
            {/* {isMobile && <Chip label="Mobile Device" className={classes.mobileChip} size="small" />} */}
          </Box>
        </Box>

        {!isOptimal && (
          <>
            <Typography variant="body1" paragraph style={{ fontWeight: 'bold', marginTop: '16px' }}>
              {isMobile
                ? 'Mobile-optimized solutions:'
                : isTablet
                ? 'Tablet-specific solutions:'
                : 'Choose a solution that works best for you:'}
            </Typography>

            {solutions.map((solution) => (
              <Accordion
                key={solution.id}
                className={`${classes.solutionAccordion} ${
                  solution.primary ? classes.primarySolution : solution.mobile ? classes.mobileSolution : ''
                }`}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.solutionHeader}>
                  <Box display="flex" alignItems="center" width="100%">
                    {solution.icon}
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                      {solution.title}
                    </Typography>
                    {solution.primary && (
                      <Chip
                        label="Recommended"
                        className={classes.recommendedChip}
                        size="small"
                        style={{ marginLeft: 'auto' }}
                      />
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails>{solution.content}</AccordionDetails>
              </Accordion>
            ))}
          </>
        )}

        {/* <Box
          mt={2}
          p={2}
          style={{ borderRadius: '8px' }}
          className={isOptimal ? classes.proTipOptimal : classes.proTipWarning}
        >
          <Typography variant="body2" style={{ fontStyle: 'italic' }}>
            <strong>Pro Tip:</strong> The content optimization experience works best on screens 1600px or wider for
            clear visibility and smooth interaction. A larger display ensures optimal layout, readability, and usability
            across all features.
            {isOptimal && ' You now have the perfect setup for the best user experience!'}
            {isMobile && ' Consider using a desktop or laptop for the full feature set.'}
          </Typography>
        </Box> */}
      </DialogContent>

      <DialogActions className={classes.actionButtons}>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          className={classes.buttonPrimary}
          style={{
            backgroundColor: '#1D3557',
            color: 'white',
          }}
        >
          {isOptimal ? 'Awesome!' : 'Got It!'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScreenSizeWarning;
